import React, { useState } from 'react';
import {
  AppBar,
  Toolbar,
  Typography,
  IconButton,
  Select,
  MenuItem,
  FormControl,
  Button,
  Box,
  Container,
  Paper,
  Alert,
  Menu,
  Badge,
  Divider
} from '@mui/material';
import {
  Apps as AppsIcon,
  Notifications as NotificationsIcon,
  AccountCircle as AccountCircleIcon,
  Description as DescriptionIcon
} from '@mui/icons-material';

export default function DataEntryInterface() {
  const [dataSet, setDataSet] = useState('');
  const [orgUnit, setOrgUnit] = useState('Zuruco Healthcare Hospital');
  const [period, setPeriod] = useState('');
  const [anchorEl, setAnchorEl] = useState(null);

  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh', bgcolor: '#f5f5f5' }}>
      {/* App Bar */}
      <AppBar position="static" sx={{ bgcolor: '#2c6693' }}>
        <Toolbar>
          <Typography variant="h6" component="div" sx={{ flexGrow: 0, mr: 3, fontSize: '0.95rem' }}>
            DHIS 2 - Data Entry
          </Typography>
          
          <Box sx={{ flexGrow: 1 }} />
          
          <IconButton color="inherit" sx={{ mr: 1 }}>
            <Badge badgeContent={0} color="error">
              <NotificationsIcon />
            </Badge>
          </IconButton>
          
          <IconButton color="inherit" sx={{ mr: 1 }} onClick={handleMenuOpen}>
            <AppsIcon />
          </IconButton>
          
          <IconButton color="inherit">
            <AccountCircleIcon />
          </IconButton>
          
          <Menu
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={handleMenuClose}
          >
            <MenuItem onClick={handleMenuClose}>Dashboard</MenuItem>
            <MenuItem onClick={handleMenuClose}>Data Entry</MenuItem>
            <MenuItem onClick={handleMenuClose}>Reports</MenuItem>
          </Menu>
        </Toolbar>
      </AppBar>

      {/* Filter Bar */}
      <Paper elevation={1} sx={{ p: 2, mb: 0, borderRadius: 0 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, flexWrap: 'wrap' }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Typography variant="body2" sx={{ minWidth: '70px' }}>
              Data set
            </Typography>
            <FormControl size="small" sx={{ minWidth: 200 }}>
              <Select
                value={dataSet}
                onChange={(e) => setDataSet(e.target.value)}
                displayEmpty
                sx={{ bgcolor: 'white' }}
              >
                <MenuItem value="">
                  <em>Choose a data set</em>
                </MenuItem>
                <MenuItem value="dataset1">Dataset 1</MenuItem>
                <MenuItem value="dataset2">Dataset 2</MenuItem>
              </Select>
            </FormControl>
          </Box>

          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Typography variant="body2" sx={{ minWidth: '110px' }}>
              Organisation unit
            </Typography>
            <FormControl size="small" sx={{ minWidth: 250 }}>
              <Select
                value={orgUnit}
                onChange={(e) => setOrgUnit(e.target.value)}
                sx={{ bgcolor: 'white' }}
              >
                <MenuItem value="Zuruco Healthcare Hospital">Zuruco Healthcare Hospital</MenuItem>
                <MenuItem value="Other Hospital">Other Hospital</MenuItem>
              </Select>
            </FormControl>
          </Box>

          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Typography variant="body2" sx={{ minWidth: '50px' }}>
              Period
            </Typography>
            <FormControl size="small" sx={{ minWidth: 150 }}>
              <Select
                value={period}
                onChange={(e) => setPeriod(e.target.value)}
                displayEmpty
                sx={{ bgcolor: 'white' }}
              >
                <MenuItem value="">
                  <em>Select period</em>
                </MenuItem>
                <MenuItem value="2025-01">January 2025</MenuItem>
                <MenuItem value="2024-12">December 2024</MenuItem>
              </Select>
            </FormControl>
          </Box>

          <Button 
            variant="text" 
            size="small" 
            sx={{ ml: 'auto', textTransform: 'none' }}
          >
            Clear selections
          </Button>

          <Button 
            variant="outlined" 
            size="small"
            sx={{ textTransform: 'none' }}
          >
            Options
          </Button>
        </Box>
      </Paper>

      {/* Main Content Area */}
      <Container maxWidth={false} sx={{ flexGrow: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', py: 4 }}>
        <Box sx={{ textAlign: 'center', maxWidth: 500 }}>
          <Box sx={{ mb: 3, display: 'flex', justifyContent: 'center' }}>
            <Box
              sx={{
                width: 80,
                height: 80,
                border: '2px solid #757575',
                borderRadius: 1,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                bgcolor: 'white'
              }}
            >
              <DescriptionIcon sx={{ fontSize: 40, color: '#757575' }} />
            </Box>
          </Box>
          
          <Typography variant="h6" gutterBottom sx={{ fontWeight: 500, color: '#333' }}>
            Get started with data entry
          </Typography>
          
          <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
            Choose a data set, organisation unit, and period from the top bar
            to start entering data
          </Typography>
          
          <Button 
            variant="text" 
            size="small"
            sx={{ textTransform: 'none', color: '#1976d2' }}
          >
            Learn more about data entry
          </Button>
        </Box>
      </Container>

      {/* Warning Alert */}
      <Box sx={{ position: 'fixed', bottom: 20, left: '50%', transform: 'translateX(-50%)', zIndex: 1000 }}>
        <Alert 
          severity="warning" 
          sx={{ 
            boxShadow: 3,
            '& .MuiAlert-icon': {
              color: '#000'
            },
            bgcolor: '#ffd54f',
            color: '#000'
          }}
          onClose={() => {}}
        >
          The Period (2025 December) is not open or is invalid.
        </Alert>
      </Box>
    </Box>
  );
}